import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import './MediaQuery.css';
import Terms from './pages/Terms.jsx';
// import Privacy from './pages/Privacy.jsx';
// import Accordion from './pages/Accordion.js';
// import Banner from './pages/Banner/Banner.jsx';
// import FAQs from './pages/FAQs.jsx';
// import Terms from './pages/Terms.jsx';
// import TermsUpdate from './pages/TermsUpdate.jsx';

const App = () => {
  return (
    // <div className='wrapper'>
    //             <Accordion />
    //           </div>
   
     <BrowserRouter basename={process.env.REACT_APP_BASE_URL}>
      <div className='App'>
        <Sidebar>
          <Routes>
            <Route path="/tnc" element={<Terms />} />
            {/* <Route index path="/privacy-policy" element={<Privacy />} /> */}
            {/* <Route path="/faqs-acc" element={<Accordion />} /> */}
            {/* <Route path="/tandc-normal" element={<TermsUpdate />} /> */}
            {/* <Route path="/faqs" element={<FAQs />} /> */}
            {/* <Route path="/banner" element={<Banner />} /> */}
          </Routes>
        </Sidebar>
      </div>
    </BrowserRouter> 

  );
};

export default App;